import localizationStrings from "./localization";
const copy = {
  eng: {
    assistant: "Your AI discovery companion",
    eyebrow: "A LITTLE INSPIRATION",
    title: "What are we watching tonight?",
    description: "Tell me your mood. Let's find a story you'll love.",
    prompts: [
      "Find me a great sci-fi movie",
      "Something for the whole family",
      "I need a feel-good film"
    ],
    placeholder: "A movie, a mood, a little inspiration…",
    send: "Send message",
    close: "Close Compass",
    thinking: "Finding a little inspiration…",
    error: "I couldn't connect right now. Please try again.",
    retry: "Try again",
    note: "Made for your next great discovery.",
    you: "You",
    conversation: "Conversation with Atlas Compass"
  },
  tr: {
    assistant: "Yapay zekâ destekli keşif rehberin",
    eyebrow: "BİRAZ İLHAM",
    title: "Bu akşam ne izlesek?",
    description: "Ruh halini anlat. Seveceğin bir hikâyeyi birlikte bulalım.",
    prompts: [
      "Güzel bir bilim kurgu filmi öner",
      "Ailece izleyebileceğimiz bir şey",
      "İyi hissettiren bir film arıyorum"
    ],
    placeholder: "Bir film, bir ruh hali, biraz ilham…",
    send: "Mesajı gönder",
    close: "Compass’ı kapat",
    thinking: "Senin için bir şeyler düşünüyorum…",
    error: "Şu anda bağlantı kuramadım. Tekrar deneyebilirsin.",
    retry: "Tekrar dene",
    note: "Sıradaki güzel keşfin için.",
    you: "Sen",
    conversation: "Atlas Compass ile sohbet"
  },
  arb: {
    assistant: "رفيق اكتشاف مدعوم بالذكاء الاصطناعي",
    eyebrow: "قليل من الإلهام",
    title: "ماذا نشاهد الليلة؟",
    description: "أخبرني عن مزاجك. لنجد قصة تحبها.",
    prompts: ["اقترح فيلم خيال علمي", "شيء يناسب العائلة", "أبحث عن فيلم مبهج"],
    placeholder: "فيلم، مزاج، قليل من الإلهام…",
    send: "إرسال الرسالة",
    close: "إغلاق Compass",
    thinking: "نبحث عن بعض الإلهام…",
    error: "تعذر الاتصال الآن. يرجى المحاولة مرة أخرى.",
    retry: "إعادة المحاولة",
    note: "من أجل اكتشافك الرائع التالي.",
    you: "أنت",
    conversation: "محادثة مع Atlas Compass"
  }
};
export const getCompassCopy = () =>
  copy[localizationStrings.getLanguage()] || copy.eng;
